import { BasicData, BasicDataRequest } from '@/models/Profile';

type ResolveCountryIsoCode = (country?: string) => string | undefined;
type ResolveCityForBasicUpdate = (
  countryIsoCode?: string,
  city?: string,
) => Promise<string>;

const buildAcceptedBasicUpdate = async (
  previewBasic: BasicData | undefined,
  mergedBasic: BasicData | undefined,
  resolveCountryIsoCode: ResolveCountryIsoCode,
  resolveCityForBasicUpdate: ResolveCityForBasicUpdate,
): Promise<BasicDataRequest | null> => {
  if (!previewBasic || !mergedBasic) return null;

  const countryIsoCode = resolveCountryIsoCode(mergedBasic.country) ?? '';
  let city = mergedBasic.city ?? '';

  if (previewBasic.city !== undefined && countryIsoCode) {
    city = await resolveCityForBasicUpdate(countryIsoCode, mergedBasic.city);
  }

  return {
    city,
    countryIsoCode,
    profileSummary: mergedBasic.profileSummary,
  };
};

export default buildAcceptedBasicUpdate;
